export default __webpack_public_path__ + "static/topic10-5bd01e6104ee59b923962fef9e734554.png";